// extracted by mini-css-extract-plugin
export default {"mainLayout":"MainLayout_mainLayout__mYD9j","boxed":"MainLayout_boxed__cm-gq"};